import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {EnvService} from '../models/env.service';
import UuidHelper from './uuid.helper';

@Injectable({
  providedIn: 'root',
})

@Injectable()
export class MonitoringService {
  appInsights: ApplicationInsights;

  constructor(private envProvider: EnvService) {

    if(this.envProvider.environment.appInsightsLogs){
      this.appInsights = new ApplicationInsights({
        config: {
          connectionString: `InstrumentationKey=${environment.appInsights.instrumentationKey};IngestionEndpoint=https://westus2-1.in.applicationinsights.azure.com/`,
          enableCorsCorrelation: true,
          autoTrackPageVisitTime:true,
        }
      });
      this.appInsights.loadAppInsights();
      this.appInsights.context.user.id = localStorage.getItem('operatorEmail'); // Operator ID
      this.appInsights.context.application.ver= this.envProvider.environment.versionNumber;
      this.appInsights.context.session.id = UuidHelper.create_UUID();
      this.loadCustomTelemetryProperties();
    }


  }

  private loadCustomTelemetryProperties() {
    this.appInsights.addTelemetryInitializer(envelope => {
      let item = envelope.baseData;
      item.properties = item.properties || {};
      item.properties['ApplicationPlatform'] = 'Web';
      item.properties['ApplicationName'] = 'AxtraxPro';
      item.properties['appVersion'] = this.envProvider.environment.versionNumber;
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    if(this.envProvider.environment.appInsightsLogs) {
      this.appInsights.trackEvent({name}, properties);
    }
  }
  trackPageView(name: string, properties?: { [key: string]: any }) {
    if(this.envProvider.environment.appInsightsLogs) {
      this.appInsights.trackPageView({name, properties});
    }
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    if(this.envProvider.environment.appInsightsLogs) {
      this.appInsights.trackMetric({name, average}, properties);
    }
  }

  logException(exception: Error, severityLevel?: number) {
    if(this.envProvider.environment.appInsightsLogs) {
      this.appInsights.trackException({exception, severityLevel});
    }
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    if(this.envProvider.environment.appInsightsLogs) {
      this.appInsights.trackTrace({message}, properties);
    }
  }
}
